import { CircularProgress } from '@material-ui/core';
import { CircularProgressProps } from '@material-ui/core/CircularProgress';
import { ContentPosition } from 'csstype';
import React from 'react';
import styled from 'styled-components';

interface ILoadingProps extends CircularProgressProps {
  vertical?: ContentPosition;
  horizontal?: ContentPosition;
  padding?: number;
}

const Root = styled.div<ILoadingProps>`
  display: flex;
  flex-direction: column;

  ${({ vertical, horizontal }) =>
    (vertical || horizontal) &&
    `
        justify-content: ${vertical};
        align-items: ${horizontal};
  `}

  ${({ padding, theme }) => padding && `padding: ${theme.spacing(padding)}px`}
`;

export const Loading: React.FC<ILoadingProps> = ({
  children,
  vertical,
  horizontal,
  padding,
  ...rest
}) => (
  <Root {...{ vertical, horizontal, padding }}>
    <CircularProgress size={26} color="primary" {...rest} />
    {children}
  </Root>
);
